import { Button, Logo } from '@vake/ui-kit';
import { FC, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider';
import { useIsAdmin, useIsUser } from '../../requests/reports';

const Navbar: FC = () => {
    const { token, logout } = useAuth();
    const { data: isAdmin } = useIsAdmin(token);
    const { data: isUser } = useIsUser(token);
    const [showNavButtons, setShowNavButtons] = useState(false);
    const [showNothing, setShowNothing] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            if (location.pathname.startsWith('/story')) {
                //special case for handling stories, which are navigated through scrolling
                setScrolled(false);
            } else {
                setScrolled(window.scrollY > 10);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [location.pathname]);

    useEffect(() => {
        const pagesWithoutNavigationButtons = [
            '/admin',
            '/overwatch-reports',
            '/visualize_candidates',
            '/clearview',
            '/demo',
            '/overwatch',
            '/search',
            '/user',
            '/pathfinder',
        ];
        const pagesShowNothing = ['/actor', '/pathfinder/', '/v2/overwatch', '/home'];
        let withoutNavigationButtonFoundInArray: boolean = false;
        let showNothingFoundInArray: boolean = false;
        for (let i = 0; i < pagesWithoutNavigationButtons.length; i++) {
            if (location.pathname.startsWith(pagesWithoutNavigationButtons[i])) {
                withoutNavigationButtonFoundInArray = true;
            }
            if (location.pathname.startsWith(pagesShowNothing[i])) {
                showNothingFoundInArray = true;
            }
        }
        if (showNothingFoundInArray) {
            setShowNothing(true);
        } else {
            setShowNothing(false);
        }
        if (withoutNavigationButtonFoundInArray) {
            setShowNavButtons(false);
        } else {
            setShowNavButtons(true);
        }
    }, [location]);

    if (showNothing) {
        return <></>;
    }
    return (
        <header
            className={`fixed top-0 flex justify-between p-2 items-center left-0 w-full z-50 bg-white shadow transition-all duration-1000 ${
                scrolled ? 'bg-background-primary' : 'bg-transparent'
            }`}
        >
            <Link to="/">
                <Logo width={72} />
            </Link>
            <div className="flex gap-2">
                {showNavButtons && (
                    <>
                        <Link to="https://user-docs-client.vake.ai/">
                            <Button size="xsmall" variant="neutral" text="Docs" />
                        </Link>
                        <Link to="/press-release">
                            <Button size="xsmall" variant="neutral" text="News" />
                        </Link>
                        <Link to="/careers">
                            <Button size="xsmall" variant="neutral" text="Careers" />
                        </Link>
                        <Link to="/about">
                            <Button size="xsmall" variant="neutral" text="About" />
                        </Link>
                    </>
                )}
                {token && isAdmin && (
                    <Link to="/admin">
                        <Button size="xsmall" id="admin-button" variant="neutral" text="Admin" />
                    </Link>
                )}
                {token && !isAdmin && isUser && (
                    <Link to="/user">
                        <Button size="xsmall" variant="neutral" text="Dashboard" />
                    </Link>
                )}
                {token ? (
                    <Button size="xsmall" variant="neutral" onClick={() => logout()} text="Log out" />
                ) : (
                    <Link to="/login">
                        <Button size="xsmall" variant="neutral" text="Login" />
                    </Link>
                )}
            </div>
        </header>
    );
};

export default Navbar;
